import React from "react";
import { motion, AnimatePresence } from "motion/react";
import { Loader2, CheckCircle2, AlertCircle, Clock, CheckSquare, Trash2, User, AlertTriangle } from "lucide-react";

export default function TaskCard({ task, onDelete, onClick }) {
  // If task is undefined/null, render nothing to avoid crashes
  if (!task) return null;

  const { title, description, expectedResult, priority, status, assignee } = task;

  return (
    <motion.div
      layout
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, scale: 0.95 }}
      onClick={() => onClick && onClick(task.id)}
      className={`bg-[#1c1c1c] border ${status === 'DONE' ? 'border-green-900/40' : 'border-[#2a2a2a]'} rounded-xl p-5 hover:border-primary-700/50 hover:shadow-lg transition-all relative group cursor-pointer`}
    >
      <div className="mb-3">
        <div className="flex flex-wrap items-center gap-2 mb-2">
          {status === 'IN_PROGRESS' && (
            <span className="inline-flex items-center gap-1 text-[10px] uppercase tracking-wider bg-blue-500/10 text-blue-400 px-2 py-0.5 rounded border border-blue-500/20 font-medium">
              <Clock className="w-3 h-3" /> В работе
            </span>
          )}
          {(status === 'IN_REVIEW' || status === 'REVIEW') && (
            <span className="inline-flex items-center gap-1 text-[10px] uppercase tracking-wider bg-amber-500/10 text-amber-400 px-2 py-0.5 rounded border border-amber-500/20 font-medium">
              <CheckSquare className="w-3 h-3" /> На проверке
            </span>
          )}
          {status === 'DONE' && (
            <span className="inline-flex items-center gap-1 text-[10px] uppercase tracking-wider bg-green-500/10 text-green-400 px-2 py-0.5 rounded border border-green-500/20 font-medium">
              <CheckCircle2 className="w-3 h-3" /> Завершена
            </span>
          )}
          
          {priority === 'URGENT' && (
            <span className="inline-flex items-center gap-1 text-[10px] uppercase tracking-wider bg-red-500/10 text-red-400 px-2 py-0.5 rounded border border-red-500/20 font-medium">
              <AlertTriangle className="w-3 h-3" /> Срочно
            </span>
          )}
        </div>
        <h3 className="text-lg font-normal text-neutral-100 line-clamp-2 leading-tight">
          {title || "Без названия"}
        </h3>
      </div>

      <div className="space-y-3">
        {description && (
          <div>
            <span className="block text-[10px] uppercase tracking-wider font-semibold text-neutral-500 mb-0.5">Описание</span>
            <p className="text-sm font-light text-neutral-300 line-clamp-2">
              {description}
            </p>
          </div>
        )}

        {expectedResult && (
          <div>
            <span className="block text-[10px] uppercase tracking-wider font-semibold text-neutral-500 mb-0.5">Ожидаемый результат (DoD)</span>
            <p className="text-sm font-light text-neutral-300 line-clamp-2">
              {expectedResult}
            </p>
          </div>
        )}
      </div>

      <div className="mt-5 flex items-center justify-between border-t border-neutral-800/60 pt-3">
        <div className="flex items-center gap-1.5 text-xs font-light text-neutral-400">
          <User className="w-3.5 h-3.5" />
          <span className="truncate max-w-[120px]">
            {assignee?.name || "Не назначен"}
          </span>
        </div>

        <button
          onClick={(e) => {
            e.stopPropagation(); // Предотвращаем клик по самой карточке
            onDelete(task.id);
          }}
          className="text-neutral-500 hover:text-red-400 transition-colors p-1.5 rounded-md hover:bg-neutral-800/50 opacity-0 group-hover:opacity-100 focus:opacity-100"
          title="Удалить задачу"
        >
          <Trash2 className="w-4 h-4" />
        </button>
      </div>
    </motion.div>
  );
}
